<template>
  <v-container>
    <v-card elevation="1" class="mx-auto" max-width="600">
      <v-card-text>
        <div class="mx-auto text-center" v-if="isSubscribed">
          <h1 class="text-h6 mb-5">
            You will not receive any notification after you unsubscribe, are you
            sure to unsubscribe ?
          </h1>
          <v-divider class="mb-5"></v-divider>
          <v-btn to="/" x-large elevation="0" color="grey" text class="mr-2">
            Cancel</v-btn
          >
          <v-btn x-large elevation="0" color="red" @click="unsubscribe()">
            <v-icon>mdi-bell-off-outline</v-icon>
            Unsubscribe</v-btn
          >
        </div>
        <div class="text-center" v-else>
          <h1 class="h1">You don't have any active Subscription.</h1>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import {messaging} from "../firebase/firebase";
export default {
  data: () => ({
    isSubscribed: null,
  }),
  methods: {
    unsubscribe() {
      messaging
        .getToken({
          vapidKey:
            "BBdKP0lNlxJ6tAieALertQc2KIV_p-U1euF7fK9bycOQRfUiFB-SspSQ9vt5_5s9dQXYN1B1ecH8dnCnGl-2wz4",
        })
        .then((currentToken) => {
          axios
            .post("https://kanak.digital/api/unsubscribe", {
              token: currentToken,
            })
            .then(() => {
              localStorage.setItem("isSubscribed", false);
              this.isSubscribed = false;
            });
        });
    },
  },
  created() {
    this.isSubscribed = JSON.parse(localStorage.getItem("isSubscribed"));
  },
};
</script>

<style>
</style>